import type { DynamicNames, HighOrderItems, MapToParser } from '@ps-smart-cp/ppfw-client';
import { useSummaryGenerator } from '@ps-smart-cp/ppfw-client';
import { useState } from 'react';
import type { MstListSearch } from '../models';

function useMstListSearch<T extends MstListSearch>(
  init: () => T,
  items: HighOrderItems<T>,
  parsers?: MapToParser<T>,
  options?: { dynamicNames?: DynamicNames<T> },
) {
  const generator = useSummaryGenerator();
  const createSummary = (t: T) => () => generator.with(t, items, parsers, options).generate();
  const [mstSearch, setMstSearch] = useState(init);
  const [summary, setSummary] = useState(createSummary(init()));
  const onClose = () => setSummary(createSummary(mstSearch)());

  return {
    mstSearch,
    setMstSearch,
    summary,
    onClose,
  };
}

export { useMstListSearch };
